<template>
<div>
    <BlockUI v-if="loading">
        <div class="loader"></div>
    </BlockUI>
    <b-dropdown text="Import" class="m-md-2" right>
        <b-dropdown-item 
            v-for="option in options" 
            :key="option.service_id" 
            @click="upload(option.key)"
        >
            {{option.text}}
        </b-dropdown-item>
    </b-dropdown>
    <UpLoadFile 
        ref="uploadFile"
        :sheets="settingUpload.sheets"
        :header="settingUpload.header"
        v-show="false" 
        @onSuccess="onUploadSuccess"
        @onLoad="isLoad"
    />
    <ModalShopAvailble 
        :setting="modalShopAvailble" 
        :confirm="modalShopAvailbleConfirm"
        :close="hideModalShopAvaible"
    />
</div>
</template>
<script>
import UpLoadFile from '@/components/custom/pos/ImportExcel'
import ModalShopAvailble from './Modal/ShopAvailble.vue'
import moment from 'moment'

const [SHOPPEE_COL_SHOPNAME, SHOPPEE_COL_TRACKING_CODE, SHOPPEE_COL_CREATED_AT] = ['drop_off_station', 'shipment_id', 'drop_off_outbound_time']
const [ADD_ORDER_API, CHECK_SHOPS] = [
    '/shippop/service/dropoff/import',
    '/shippop/service/dropoff/shop/available'
    ]
let DEFAULT_NAME_COLS = {
    shopName: null,
    trackingCode: null,
    type: null,
    createdAt: null,
    dateTimeShipping: null,
    status: null,
}
export default {
    name: 'ImportExcel',
    components:{
        UpLoadFile,
        ModalShopAvailble
    },
    props:{
        services:{
            type: Array,
            default: []
        }
    },
    data(){
        return {
            loading: false,
            selected: null,
            json: null,
            settingUpload: {
                header: 0,
                sheets: false,
                key: null
            },
            modalShopAvailble:{
                isShow: false,
                listShop: []
            }
        }
    },
    methods:{
        reset(){
            this.json = null
            this.selected = null
            this.settingUpload.header = 0
            this.settingUpload.sheets = false
            this.settingUpload.key = null
            this.modalShopAvailble.isShow = false
            this.modalShopAvailble.listShop = []
        },
        isLoad( status = true ){
            this.loading = status
        },
        upload( type ){
            const checkType = this.checkTypeDropoff( type )
            this.chageSettingUpload( checkType )
            this.$nextTick( () => {
                let self = this
                self.$refs.uploadFile.$el.click()
            })
        },
        checkTypeDropoff( type ){
            if( type === this.serviceKeys.SPX )return { h: 1, s: true, k: type }
            return { h: 0, s: false, k: type }
        },
        async onUploadSuccess( val ){
            this.isLoad()
            try{
                let data = val.data
                if( this.settingUpload.key === this.serviceKeys.SPX ){
                    data = this.convertFromatObjByShoppee( val.data )
                }
                this.json = this.setFormatNameCols( data , this.settingUpload.key )
                const shopAvailble = await this.checkAvailbleShops( this.json )
                this.modalShopAvailbleHandler( shopAvailble )

            } catch ( err ){
                // eslint-disable-next-line
                console.error( err )
            }
            this.isLoad( false )
        },
        convertFromatObjByShoppee( objs ){
            let startOnRow
            let listCol = {}
            let data = []
            for( let key in objs ){
                let obj = objs[key]
                let rawHeader = obj.find( (cols, i) => {
                    const findCols = cols.find( col => {
                        return col == 'shipment_id'
                    })
                    if( findCols ){
                        startOnRow = i
                        return findCols
                    }
                })
                rawHeader.forEach((val, key) => {
                    if( val ){
                        listCol[key] = val
                    }
                })
                let rawRows = obj
                rawRows = rawRows.slice( startOnRow + 1 )
                const IndexOfCol = Object.keys( listCol )
                let rows = rawRows.filter( el => {
                    return !!el[IndexOfCol[0]]
                })
                rows.forEach( row => {
                    let tmp = {}
                    for( const i in listCol ){
                        tmp[listCol[i]] = row[i]
                    }
                    data.push( tmp )
                })
            }
            return data
        },
        setFormatNameCols( data, type ){
            let res = []
            data.forEach( ele => {
                let def = { ...DEFAULT_NAME_COLS }
                if( type === this.serviceKeys.SPX ){
                    for( const key in ele ){
                        if( key === SHOPPEE_COL_SHOPNAME ){
                            def.shopName = ele[key]
                        }else if( key === SHOPPEE_COL_TRACKING_CODE ){
                            def.trackingCode = ele[key]
                        }else if( key === SHOPPEE_COL_TRACKING_CODE ){
                            def.trackingCode = ele[key]
                        }else if( key === SHOPPEE_COL_CREATED_AT ){
                            def.createdAt = this.convertDateTime( ele[key], "YYYY-MM-DD" )
                        }
                    }
                }else{
                    const _ele = Object.values(ele)
                    let dateFromFormat = 'DD-MM-YYYY H:mm:ss'
                    def.shopName = _ele[0]
                    def.trackingCode = _ele[1]
                    def.type = _ele[2]
                    if( type === this.serviceKeys.LZDS)
                    dateFromFormat = 'DD-MM-YYYY-HH-mm-ss'

                    if( type === this.serviceKeys.DHL )
                    dateFromFormat = 'DD/MM/YYYY HH:mm'

                    def.createdAt = this.convertDateTime( _ele[3], dateFromFormat )
                    def.dateTimeShipping = this.convertDateTime( _ele[4], dateFromFormat )
                    def.status = _ele[5]
                }
                res.push( def )
                
            })
            return res
        },
        convertDateTime( dateTime, fromFormat ){
            return moment( dateTime, fromFormat ).format( "YYYY-MM-DD" )
        },
        resetSettingUpload(){
            this.settingUpload.header = 0
            this.settingUpload.sheets = false
        },
        chageSettingUpload( config ){
            this.settingUpload.header = config.h
            this.settingUpload.sheets = config.s
            this.settingUpload.key = config.k
        },
        async checkAvailbleShops( data ){
            const shops = this.groupByShop( data )
            const availbleShops = await this.checkAvailbleShopsAPI( shops )
            return availbleShops.data.data
        },
        groupByShop( data ){
            return data.reduce(function(result, detail){
                if( !result.includes(detail.shopName) )result.push( detail.shopName )
                return result
            }, [])
        },
        async checkAvailbleShopsAPI( shops ){
            const requestData = {
                key: this.settingUpload.key,
                data: shops 
            }
             const header = {
                headers:{
                    Token: this.$TOKEN
                }
            }
            return await this.$http.post( this.$API_URL + CHECK_SHOPS, requestData, header )
        },
        modalShopAvailbleConfirm( shopAvailble ){
            const orders = this.filterOrderByShop( shopAvailble, this.json )
            this.addOrderAPI( orders )
            alert( "ร้องขอเพิ่มรายการสำเร็จ รายการจะเพิ่มเข้าในระบบภายใน 10-20 นาที")
            this.hideModalShopAvaible()
        },
        filterOrderByShop( shops, orders ){
            let data = []
            shops.forEach( shop => {
                let results = orders.reduce( (result, order) => {
                    if( order.shopName === shop.shop_name ){
                        order.shopId = shop.shop_id
                        result.push( order )
                    }
                    return result
                }, [])
                data = [ ...data, ...results ]
            })
            return data
        },
        async addOrderAPI( data ){
            const requestData = {
                key: this.settingUpload.key,
                data: data 
            }
            const header = {
                headers:{
                    Token: this.$TOKEN
                }
            }
            const add = await this.$http.post( 
                this.$API_URL + ADD_ORDER_API, requestData, header 
            )
            return add

        },
        showModalShopAvailble(){
            this.modalShopAvailble.isShow = true
        },
        hideModalShopAvaible(){
            this.reset()
        },
        modalShopAvailbleHandler( shopAvailble ){
            this.showModalShopAvailble()
            this.modalShopAvailble.listShop = shopAvailble
        }

    },
    computed:{
       options(){
            let response = []
            if( this.services.length > 0 ){
                response = this.services.reduce( (results, service) => {
                    results.push({
                        value: service.service_id,
                        key: service.key,
                        text: service.name
                    })
                    return results
                }, [])
            }
            return [ ...response ]
        },
        serviceKeys(){
            let response = {}
            if( this.services.length > 0 ){
                response = this.services.reduce( (results, service) => {
                    results[service.key] = service.key
                    return results
                }, {})
            }
            return { ...response }
        }
    }
}
</script>